import { useEffect, useState } from 'react';

import {
  CHECKOUT_PICKUP_TIME_DISPLAY_INTERVAL_MS,
  PICKUP_SLOT_REFRESH_INTERVAL_MS,
} from './earliest-pickup-time';

/** Bumps every interval so client-side slot filters re-run against the current time. */
export function usePickupSlotRefreshTick(
  intervalMs = PICKUP_SLOT_REFRESH_INTERVAL_MS
): number {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setTick(t => t + 1);
    }, intervalMs);

    return () => clearInterval(id);
  }, [intervalMs]);

  return tick;
}

/** Bumps every minute so checkout ASAP label and offer pickUpTime stay aligned with now. */
export function useCheckoutPickupTimeDisplayTick(
  intervalMs = CHECKOUT_PICKUP_TIME_DISPLAY_INTERVAL_MS
): number {
  return usePickupSlotRefreshTick(intervalMs);
}
